import { Input } from "@elaniintc/goes-design-system";
import { VariableSelector } from "./VariableSelector";
import { getPlaceholder, getRestrictionFunction } from "./comparativeValues";
import type { ComparativeValueInputProps, Variable } from "./types";
import ComparativeValueInputCalendar from "./ComparativeValueInput.calendar";

export const ComparativeValueInput = ({
  selectedVariable,
  selectedOperation,
  comparativeValue,
  onValueChange,
  variables,
  group,
}: ComparativeValueInputProps) => {
  if (!selectedOperation?.needsComparativeValue) {
    return null;
  }

  if (
    selectedOperation.comparativeValueType !== "variable" &&
    selectedVariable?.type === "date"
  ) {
    return (
      <ComparativeValueInputCalendar
        group="down-right"
        defaultDate={comparativeValue as string}
        onChangeDate={onValueChange}
      />
    );
  }

  if (selectedOperation.comparativeValueType !== "variable") {
    return (
      <Input
        group={group}
        className="w-full"
        placeholder={getPlaceholder(
          selectedOperation.comparativeValueType || "",
        )}
        value={comparativeValue as string}
        onChange={(e) => {
          const func = getRestrictionFunction(
            selectedOperation.comparativeValueType || "",
          );
          onValueChange(func(e.target.value));
        }}
      />
    );
  }

  if (selectedOperation.comparativeValueType === "variable") {
    return (
      <VariableSelector
        variables={variables
          .map((v) => {
            return {
              ...v,
              variables: (v.variables ?? []).filter(({ type }) => {
                return type === selectedVariable?.type;
              }),
            };
          })
          .filter(({ variables }) => {
            return variables.length > 0;
          })}
        selectedVariable={comparativeValue as Variable}
        onSelectVariable={(variable) => onValueChange(variable || "")}
        triggerGroup={group}
      />
    );
  }
};
